import { Box, FormHelperText } from "@mui/material";
import { FieldError } from "react-hook-form";

interface Props {
  error?: FieldError;
}

export const CustomFormHelperText = (props: Props) => {
  if (!props.error) return null;

  return (
    <FormHelperText>
      <Box
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        gap={0.5}
      >
        <img src="/img/tick-circle.svg" alt="btn" />
        {props.error.message?.toString()}
      </Box>
    </FormHelperText>
  );
};
